import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RegionModel } from '../models/region.model';
import { InfraService } from './infra.service';


@Injectable()
export class RegionService {
    private configUrl: string;
    private apiCoreUrl: string;

  constructor(private infraService: InfraService, private http: HttpClient) {

    this.infraService.infraDetails$.subscribe(data => {
      this.configUrl = data.WebEndPoint1 + 'region';
      this.apiCoreUrl = data.WebEndPoint2;
      
    });

    if (!this.infraService.isInfraDetailsAvailable && localStorage.getItem('selectedInfra') !== undefined) {
      this.infraService.isInfraDetailsAvailable = true;
      this.infraService.setInfraDetails(localStorage.getItem('selectedInfra'));
    }

    }

  public getRegions(): Observable<RegionModel[]> {
    return this.http.get<RegionModel[]>(`${this.apiCoreUrl}Region/GetRegions`);
  }

  public getCountriesByRegion(regionName: string): Observable<RegionModel[]> {
    return this.http.get<RegionModel[]>(`${this.apiCoreUrl}Region/GetCountriesByRegion/${regionName}`);
  }

  public getTemplates(regionId: number): Observable<RegionModel[]> {
    return this.http.get<RegionModel[]>(`${this.apiCoreUrl}Region/GetTemplates/${regionId}`);
  }
}
